import { useQuery, type UseQueryOptions } from "@tanstack/react-query"

import { getSbSizeguideByProductType } from "~/lib/storyblok/queries/get-sb-sizeguide-by-product-type"
import useLocale from "~/hooks/useLocale"
import { useQueryStatus } from "~/hooks/useQueryStatus"

type Return = Awaited<ReturnType<typeof getSbSizeguideByProductType>>

type QueryOptions = {
  throwError?: boolean
  onError?(error: Error): void
  onSuccess?(data: Return): void
} & Omit<UseQueryOptions<Return, Error, Return>, "queryFn" | "onError">

export function useGetSizeGuide(productType: string | null, queryOptions?: QueryOptions) {
  const locale = useLocale()
  const { queryKey = [], ...options } = queryOptions ?? {}

  const response = useQuery<Return, Error, Return>({
    queryKey: ["fetchSizeGuide", productType, ...queryKey],
    queryFn: async () => await getSbSizeguideByProductType({ productType, locale }),
    ...options,
  })

  useQueryStatus(response, options)

  return response
}
